import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

import { MsalService } from '@azure/msal-angular';
import { MsalAuthorizationService } from '@webgate/angular-azure-core';
import { finalize } from 'rxjs';

import { AccessService } from './services/access.service';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private titleService = inject(Title);
  msalAuthorizationService = inject(MsalAuthorizationService);
  accessService = inject(AccessService);
  msalService = inject(MsalService);
  userService = inject(UserService);

  title = 'Follow-up of Recommendations';
  public constructor() {
    this.titleService.setTitle(this.title);
  }

  ngOnInit(): void {
    this.userService.loadAllUser().subscribe();
    this.msalService
      .handleRedirectObservable()
      .pipe(finalize(() => this.msalAuthorizationService.checkIsLoggedIn()))
      .subscribe();
  }
}
